import { Helmet } from "react-helmet-async";

export function FAQSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What’s the Gallup Strengthsfinder assessment all about?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "It’s a strengths assessment which Prof. Donald Clifton developed and is used today to identify the areas that energise you as a person and where you are the most engaged. The assessment tests you on 34 strengths to determine what your 5 dominant strengths are."
        }
      },
      {
        "@type": "Question",
        "name": "Where did the Strengths idea come from?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Prof. Donald Clifton focussed on positive psychology because he realised that the way our world works is to focus on what’s wrong with us and not what’s right with us and he wanted to change that concept and hence the strengths idea was born!"
        }
      },
      {
        "@type": "Question",
        "name": "Why should I get coaching and not only do the Gallup Strengthsfinder assessment?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "An assessment without coaching is like buying a new cell phone without using the instructions, yes you’ll figure out how to use the basics of the phone but you’ll never use the full potential of the phone."
        }
      },
      {
        "@type": "Question",
        "name": "What is the credibility of the Gallup Strengthsfinder assessment?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Please take a look at our resources section at the CSF Technical Report to find out exactly how credible the Strengthsfinder assessment is."
        }
      },
      {
        "@type": "Question",
        "name": "Is it a lot of homework after each session?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No, any busy person will be able to do it. You and the coach will conclude on the amount of time you have to do the homework."
        }
      },
      {
        "@type": "Question",
        "name": "If I’m not comfortable with the coach can I get a different coach?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Definitely! We are all different and don’t relate with every single person we meet and it is very import for you to be able to relate and be comfortable with your coach. Every coach knows it’s not personal."
        }
      },
      {
        "@type": "Question",
        "name": "If I don’t enjoy the process can I stop and get my money back?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We’ve never had a case where the individual doesn’t enjoy the coaching but if you don’t enjoy the coaching you are can definitely stop with the process but a refund won’t be possible because we pay our coaches upfront."
        }
      },
      {
        "@type": "Question",
        "name": "Do I have to have the Individual coaching before I can get the Executive coaching?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No not necessarily but we recommend that you first just focus on your top 5 strengths and then only move towards the Executive coaching. The Executive coaching entails a lot of information and can some times be overwhelming if not enough time by the individual was focussed on their top 5 strengths first."
        }
      },
      {
        "@type": "Question",
        "name": "Can I pay monthly or do I have to pay it all at once?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can pay monthly or you can pay it all up front."
        }
      },
      {
        "@type": "Question",
        "name": "I’ve done a lot of personal assessments and coaching, what makes this process any different?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The detail of this process is what makes it different as well as the application of it. The strengths assessment gives a detail description of where your strengths lie and that’s the foundation of our coaching. Focus on your strengths and managing around your weaknesses."
        }
      },
      {
        "@type": "Question",
        "name": "If I’ve done other assessments can I share the information with you so that you can incorporate it in to our sessions?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our coaches are only qualified as talent coaches so for that reason we won’t be able to incorporate some of the other assessments but most of our coaches don’t only use the strengths assessment in their coaching, they also use other assessments."
        }
      },
      {
        "@type": "Question",
        "name": "I’ve done my Gallup Strengthsfinder assessment more than a year ago, can you still coach me?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "As long as you know what your top 5 strengths are we can always coach you, it doesn’t matter when you did the assessment."
        }
      },
      {
        "@type": "Question",
        "name": "Where does the coaching take place?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The individual and coach will decide on a place where both parties are comfortable for the coaching to take place."
        }
      },
      {
        "@type": "Question",
        "name": "Is coaching via Skype an option?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes definitely! Usually only the first session takes place personally and then the other sessions can take place via Skype, it all depends on the individual."
        }
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}
